import patternMaker from "./patternMaker";
import customCheckerboard from "./customCheckerboard";
import ugc from "./ugc";
import UGCEntryPoint from "./ugcEntryPoint";
import utils from "./utils";
import buyPanel from "./buyPanel";
import personalization from "./personalization";
import swatches from "./swatches";
import gdm from "./gdm";
import randomizer from "./randomizer";
import legacyNavigation from "./legacyNavigation";
import standardNavigation from "./standardNavigation";
import recipe from "./recipe";
import endPoints from "./endPoints";
import sceneSetup from "./sceneSetup";
import preloader from "./preloader";
import modals from "./modals";
import transferDesign from "./transferDesign";
import swatchMaterialGroups from "./swatchMaterialGroups";
import componentConfigGroup from "./componentConfigGroup";
import translations from "./translations";
import geometryUpdates from "./geometryUpdates";
import graphicsController from "./graphicsController";
import pickYourOwnColor from "./pickYourOwnColor";
import undo from "./undo";
import finishMyDesign from "./finishMyDesign";
import randomize from "./randomize";
import swatchTray from "./swatchTray";
import imageGallery from "./imageGallery";

export default {
  patternMaker,
  customCheckerboard,
  ugc,
  UGCEntryPoint,
  utils,
  buyPanel,
  personalization,
  swatches,
  gdm,
  randomizer,
  legacyNavigation,
  standardNavigation,
  recipe,
  endPoints,
  sceneSetup,
  preloader,
  modals,
  transferDesign,
  swatchMaterialGroups,
  componentConfigGroup,
  translations,
  geometryUpdates,
  graphicsController,
  pickYourOwnColor,
  undo,
  finishMyDesign,
  randomize,
  swatchTray,
  imageGallery
};
